<template>
    <div class="trainingMain">
        <div class="trainingBox">
            <div class="trainingLeft">
                <div class="title">
                    <p>安全培训</p>
                    <el-button type="primary" round @click="handleSchool">
                        更多<i class="el-icon-arrow-right"></i>
                    </el-button>
                </div>  
                <div class="listTrain">
                    <div class="trainingMenu">
                        <!-- <el-menu
                            ref="menu"
                            class="el-menu-vertical-demo"
                            :default-active="menuList[0].cate_id"
                            background-color="#f5f7f9"
                            text-color="#000"
                            active-text-color="#00a8a8">
                                <el-menu-item v-for="item in menuList" :key="item.cate_id" :index="item.cate_id" @click="handleMenu(item.cate_id)">{{ item.cate_name }}</el-menu-item>
                        </el-menu> -->
                        <p slot="reference" class="slotPoper" 
                            v-for="item,index in menuList" :key="item.cate_id" :index="item.cate_id" 
                            @click="handleMenu(item.cate_id,index)"
                            :class="index == menuIndex?'slotPoperColor':''"
                            >{{ item.cate_name }}</p>
                    </div>
                    
                    <div class="trainingListMain">
                        <div v-for="item in listTrain" :key="item.id" class="listItem">
                            <div @click="getTrainInfo(item)" class="listImageWidth" :style="'background-image:url('+item.firstFile.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;'"></div>
                            <p class="ItemName"  @click="getTrainInfo(item)">{{ item.name }}</p>
                            <el-button @click="Application(item)">立即报名</el-button>
                            
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="trainingRight">
                <p class="title">近期活动</p>
                <div class="trainingImg">

                </div>
                <div class="imgItem">
                    <div></div>
                    <div></div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            listTrain: [],
            menuList: [],
            menuIndex: 0

        }
    },
    methods:{
        handleSchool(){
            this.$router.push({
                path: '/train'
            })
        },
        getmMnuList(data){
            this.$store.dispatch('train/menuList',data)
                .then(res => {
                    if(res.ok){
                        console.log(res.data)
                        this.menuList = res.data

                        let listTrain = {
                            pageNum: 1,
                            pageSize: 3,
                            cate_ids: this.menuList[0].cate_id,
                            keywords: '',
                            parent_cate_value: 'train'
                        }
                        this.getListTrain(listTrain)
                    }
                })
        },
        handleMenu(id,index){
            // console.log(id);
            // this.cate_id = id
            this.menuIndex = index
            console.log("this.meunIndex--");
            console.log(this.menuIndex);
            let listTrain = {
                pageNum: 1,
                pageSize: 3,
                cate_ids: id,
                keywords: ''
            }
            this.getListTrain(listTrain)
        },
        getListTrain(data){
            this.$store.dispatch('train/listTrain',data)
                .then(res =>{
                    if(res.ok){
                        this.listTrain = res.data.items

                    }
                })
        },
        getTrainInfo(item){
            console.log(item);
            this.$router.push({
                path: '/trainInfo',
                query:{
                    key: item.id,
                }
            })
        },
        Application(item){
            this.$router.push({
                path: '/application',
                query: {
                    key: item.id
                }
            })
        }
    },
    mounted(){
        let data = {
            pageNum: 1,
            pageSize: 3,
            parent_cate_value: 'train',
            cate_values: 'train'
        }
        this.getmMnuList(data)

        
    }
}
</script>
<style scoped>
.trainingMain{
    width: 1200px;
    margin-top: 20px;
}
.trainingBox{
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* margin-top: 11px; */
}
.trainingLeft{
    width: 1180px;height: 100%;
    padding: 10px 10px;
    background: #fff;
}
.trainingLeft .title{
    /* width: 1180px; 
    border-radius: 5px;
    padding: 10px 0 10px 16px;
    border-bottom: 0.5px solid #f2f2f2;
    font-size: 22px;
    font-weight: 700; */

    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 0.5px solid #f2f2f2;
    border-radius: 5px;
}
.trainingLeft .title p{
  font-size: 22px;
  font-weight: 700;
  /* background: rgb(187, 208, 247);    */
  padding: 15px 15px;
  border-radius: 15px;
  margin-right: 60px;
}

.listTrain .trainingMenu{
    width: 200px;
    background: #fff;
    margin-top: 20px;
    /* padding: 15px 15px; */
    /*box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);*/
    align-self: flex-start;
    text-align: center;
    cursor: pointer;
}



.listTrain .trainingListMain::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.listTrain .trainingListMain::-webkit-scrollbar-track {
  background-color:transparent;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius:2em;
}
.listTrain .trainingListMain::-webkit-scrollbar-thumb {
  background-color: rgb(147,147,153,0.5);
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius:2em;
}
.trainingListMain .listItem{
    width: 280px;height: 295px;
    white-space: nowrap;
    margin: 10px 20px;
    cursor: pointer;
    padding-bottom: 3px;
    border: 1px solid #f2f2f2;
    /* border-radius: 10px; */
}

.trainingListMain .ItemName{
    margin-top: 10px;
    font-size: 18px;
    margin-left: 6px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    cursor: pointer;
}
.trainingListMain  .listItem .el-button{
    background: #00acc9;
    color: #fff;
    width: 100%;
    /* margin-left: 3px; */
    /* margin-top: 28px; */
    margin-top: 34px;
}


.trainingRight{
    width: 400px;height: 100%;
    padding: 10px 10px;
    background: #fff;
}
.trainingRight .title{
    font-size: 18px;
}
.trainingRight .trainingImg{
    width: 400px;height: 220px;
    margin-top: 10px;
    background: rgb(209, 223, 250, 0.4);
}
.trainingRight .imgItem{
    width: 400px;height: 140px;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
}
.trainingRight .imgItem div{
    width: 48%;height: 100%;
    background: rgb(209, 223, 250, 0.4);
}

.el-menu-item {
  background-color: rgba(0, 0, 0, 0.1);
  font-size: 18px;
  margin-top:1px;
}
.el-menu-item.is-active {
  background: rgb(0, 168, 168, 0.1) !important;
  border-bottom: 0px solid rgba(0, 168, 168, 0.1) !important;
}
.el-menu-item:hover{
    background: rgb(0, 168, 168, 0.1) !important;
    color: rgba(0, 168, 168);
    margin-top:1px;
}
.slotPoperColor{
  color: #008a8a;
}

@media screen and (min-width: 541px) {
    .listTrain{
        display: flex;
        justify-content: space-between;
        align-items: center;
        
    }
    .slotPoperColor{
        background: rgb(0, 168, 168, 0.1);
    }
    .listTrain .trainingMenu{
        background: #F5F7F9;
    }
    .listTrain .trainingMenu p{
        padding: 15px 10px;
    }
    
    .listTrain .trainingListMain{
        width: 965px;height: 310px;
        margin-top: 10px;
        /* margin-right: 30px; */
        display: flex;
        justify-content: flex-start;
    }
    .listImageWidth{
        width: 280px;
        height:190px
    }
}
@media screen and (max-width: 540px) {
    .trainingMain{
        width: 100%;
       
    }
    .trainingLeft{
        width: 100%;
        padding: 10px 0px;
        background: #fff;
    }
    .trainingLeft .title{
        width: 100%; 
        font-size: 18px;
        padding: 15px 5px;
        
    }
    .listTrain .trainingMenu{
        width: 90%;
        margin: 0 auto;
        display: flex;
        background: #fff;
        margin-top: 20px;
        padding: 20px  10px ;
        /*box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);*/
        justify-content: space-between;
        align-items: center;
        background: #F5F7F9;
        font-size: 16px;
    }


    .listTrain .trainingListMain{
        width: 95%;
        margin: 10px auto;
    }

    .trainingListMain .listItem{
        width: 96%;
        margin: 10px 0px;
        padding: 5px 5px;
    }
    .listImageWidth{
        width: 100%;
        height:190px
    }
   
  

}
</style>